import { SxProps, Theme } from '@mui/material';

export const tableStyles: Record<string, SxProps<Theme>> = {
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  dataGrid: {
    border: 'none',
    flex: 1,
    minHeight: 0,
    '& .MuiDataGrid-cell': {
      py: 1
    },
    '& .MuiDataGrid-columnHeaders': {
      bgcolor: 'background.paper',
      borderBottom: '2px solid',
      borderColor: 'divider'
    },
    '& .MuiDataGrid-virtualScroller': {
      bgcolor: 'background.paper'
    },
    '& .MuiDataGrid-row': {
      '&:hover': {
        bgcolor: 'action.hover'
      },
      minHeight: '52px !important',
      maxHeight: '52px !important'
    },
    '& .MuiDataGrid-cell[data-field="photo"]': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }
};